import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  JobseekerModerationAttributeEnum,
  RejectModel,
} from '../../shared/models/jobseeker-moderation.model';

@Component({
  selector: 'app-jobseeker-moderation-attachment',
  templateUrl: './jobseeker-moderation-attachment.component.html',
  styleUrls: ['./jobseeker-moderation-attachment.component.less'],
  standalone: false,
})
export class JobseekerModerationAttachmentComponent {
  @Input() documents: any;
  @Input() isCreate: boolean;
  @Input() isEdited: boolean;
  @Input() changes: any;
  @Output() setDictionary: EventEmitter<RejectModel> =
    new EventEmitter<RejectModel>();
  public jobseekerEnum: any;

  constructor() {
    this.jobseekerEnum = JobseekerModerationAttributeEnum;
  }

  reject(event) {
    this.setDictionary.emit({ key: event.key, value: event.value });
  }
  checkAddedDocuments(id: number) {
    return this.changes.jobseekerDocumentChanges?.addedDocuments?.some(
      (val) => val.jobseekerDocumentId === id
    );
  }
}
